import * as fromUser from 'src/app/@store/actions/user.actions'
import { createReducer, on, Action } from '@ngrx/store'
import defaultUserAvatarImageUrl from 'src/assets/img/profile-pic-placeholder.png'

export { defaultUserAvatarImageUrl as DEFAULT_AVATAR_URL }

export enum PermissionTypes {
  Edit = 'edit',
  View = 'view',
}

export enum UserPermissionsKeyTypes {
  Checklists = 'checklists',
  FlightNetwork = 'flight_network',
  FlightSimulation = 'flight_simulation',
  LiveMissions = 'live_missions',
  Maintenance = 'maintenance',
  Manuals = 'manuals',
  MissionHistory = 'mission_history',
  PartNumbers = 'part_numbers',
  SysAdmin = 'sys_admin',
  Users = 'users',
  Vehicles = 'vehicles',
  DiscrepancyReportSubmit = 'discrepancy_report_submit',
  DiscrepancyReports = 'discrepancy_reports',
  ChecklistReports = 'checklist_reports',
}

export type UserPermissionsObject = Record<UserPermissionsKeyTypes, PermissionTypes[]>

export interface UserState {
  id: number
  name: string
  email: string
  creation_timestamp: string
  roles: string[]
}

export interface State {
  user: UserState
  permissions: UserPermissionsObject
  avatarUrl: string
  loading: boolean
  error: any
}

export const initialState: State = {
  user: null,
  permissions: null,
  avatarUrl: defaultUserAvatarImageUrl,
  loading: false,
  error: null,
}

const userReducer = createReducer(
  initialState,
  on(fromUser.login, fromUser.logout, fromUser.authenticate, (state) => ({ ...state, loading: true })),

  on(fromUser.loginSuccess, (state) => ({ ...state })),
  on(fromUser.authenticateSuccess, (state, { user, permissions }) => ({ ...state, user, permissions, loading: false })),
  on(fromUser.logoutSuccess, () => ({ ...initialState })),

  on(fromUser.updateAvatar, fromUser.changeAvatarSuccess, (state, { url }) => ({ ...state, avatarUrl: url })),

  on(fromUser.loginFailure, fromUser.logoutFailure, fromUser.authenticateFailure, (state, { error }) => ({
    ...initialState,
    error,
    loading: false,
  })),

  on(fromUser.changeAvatarFailure, fromUser.updateAvatarFailure, (state, { error }) => ({ ...state, error })),
)

export function reducer(state: State | undefined, action: Action): State {
  return userReducer(state, action)
}

export const selectors = {
  getUser: (state: State) => state.user,
  getUserAvatarUrl: (state: State) => state.avatarUrl,
  getUserLoading: (state: State) => state.loading,
  getUserError: (state: State) => state.error,

  canUser: (state: State, props: { permissionKey: string; permissionType: string }): boolean =>
    state.permissions?.[props.permissionKey]?.some((permission: string) => permission === props.permissionType),
}
